<template>
    <div class="content_box mobile_content">
        <div class="content h5-quick-start-page">
            <!-- 标题栏 -->
            <div class="title_box title_flex" style="justify-content: space-between; align-items: center;">
                <div>
                    <h1 class="title">H5 快速开始页配置</h1>
                    <p style="margin:8px 0 0; color:#666; font-size:13px;">新用户扫码进入的快速开始页，配置产品信息和内容模块。App 下载和联系方式为全局配置，不在此维护。</p>
                </div>
                <div class="status_row">
                    <span class="status_pill">已发布</span>
                    <span style="margin-left:10px; font-size:13px; color:#666;">最近更新：{{ lastUpdateTime }}</span>
                </div>
            </div>

            <!-- 上方操作按钮 -->
            <div class="top_actions">
                <div class="button button2" @click="preview" style="background:#fff; border:1px solid #E8E9F1; color:#507FF7; margin-right:10px;">
                    <span>预览</span>
                </div>
                <div class="button button2" @click="saveDraft" style="margin-right:10px;">
                    <span>保存草稿</span>
                </div>
                <div class="button" @click="publish" style="background:#507FF7; color:#fff;">
                    <span>发布</span>
                </div>
            </div>

            <!-- 信息卡片 -->
            <div class="info_card">
                <div style="flex:1;">
                    <h2 style="font-size:15px; font-weight:850; margin-bottom:6px;">页面说明</h2>
                    <p style="color:#666; font-size:13px; line-height:1.55;">新用户扫码后看到的 H5 页面，包含产品信息、开箱安装视频、使用文档和联系方式。选择产品型号后自动带入产品名称和图片。</p>
                </div>
                <div class="source_list">
                    <span class="tag tag_ok">视频库</span>
                    <span class="tag tag_ok">文档库</span>
                </div>
            </div>

            <!-- 双列布局 -->
            <div class="layout_grid">
                <!-- 左列：配置区 -->
                <div class="left_col">
                    <!-- 页面范围 -->
                    <div class="config_card">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">页面范围</h2>
                                <p class="config_card_subtitle">选择产品型号、国家/地区和语言，产品名称与图片自动带入。模块标题将按所选语言显示。</p>
                            </div>
                            <div class="button text" style="color:#507FF7; font-weight:720; font-size:13px;">复制到其他国家</div>
                        </div>
                        <div class="filters_grid">
                            <div class="filter_field">
                                <label>产品型号</label>
                                <el-select v-model="searchForm.product" placeholder="请选择产品">
                                    <el-option v-for="item in productOptions" :label="item" :value="item" :key="item"></el-option>
                                </el-select>
                                <div class="hint">选择后自动带入产品名称和白底图</div>
                            </div>
                            <div class="filter_field">
                                <label>国家/地区</label>
                                <el-select v-model="searchForm.country" placeholder="请选择国家">
                                    <el-option label="美国" value="US"></el-option>
                                    <el-option label="德国" value="DE"></el-option>
                                    <el-option label="日本" value="JP"></el-option>
                                    <el-option label="中国" value="CN"></el-option>
                                </el-select>
                            </div>
                            <div class="filter_field">
                                <label>当前编辑语言</label>
                                <el-select v-model="searchForm.lang" placeholder="请选择语言">
                                    <el-option label="English" value="en"></el-option>
                                    <el-option label="简体中文" value="zh"></el-option>
                                    <el-option label="Deutsch" value="de"></el-option>
                                </el-select>
                            </div>
                            <div class="filter_field">
                                <label>默认兜底语言</label>
                                <el-select v-model="searchForm.fallback" placeholder="请选择语言">
                                    <el-option label="English" value="en"></el-option>
                                    <el-option label="简体中文" value="zh"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="product_preview_row">
                            <div class="product_thumb">M1</div>
                            <div>
                                <div style="font-size:15px; font-weight:780;">M1 Pro / Plus</div>
                                <div style="font-size:12px; color:#666; margin-top:2px;">自动带入 · 来自产品管理</div>
                            </div>
                        </div>
                    </div>

                    <!-- 模块配置 -->
                    <div class="config_card" style="margin-top:16px;">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">模块配置</h2>
                                <p class="config_card_subtitle">每个模块只能添加对应类型的内容。模块标题根据多语言自动展示，不支持在此修改。</p>
                            </div>
                        </div>

                        <div class="modules_container">
                            <!-- 模块1：开箱与安装视频 -->
                            <div class="module_item" data-module="unboxing-video">
                                <div class="module_header" @click="toggleModule('video')">
                                    <div class="drag_handle" title="拖拽排序">⋮⋮</div>
                                    <div style="flex:1;">
                                        <p class="module_name">开箱与安装视频</p>
                                        <div class="module_meta">
                                            <span>{{ videoItems.length }} 条内容</span>
                                            <span class="tag tag_ok">内容来自视频库</span>
                                        </div>
                                    </div>
                                    <div class="button text" @click.stop="openAddModal('video')" style="color:#507FF7; font-weight:720; font-size:13px;">+ 添加内容</div>
                                </div>
                                <div class="module_body" v-show="!videoCollapsed">
                                    <div class="content_list" ref="videoList">
                                        <div v-for="item in videoItems" :key="item.id" class="content_row_item">
                                            <div class="drag_handle drag_handle_sm">⋮</div>
                                            <div class="content_row_title">{{ item.title }}</div>
                                            <span v-if="item.duration" class="content_meta">{{ item.duration }}</span>
                                            <div class="button text del_btn" @click="removeItem('video', item)">移除</div>
                                        </div>
                                        <div v-if="videoItems.length === 0" class="empty_hint">暂无内容，点击"+ 添加内容"开始配置</div>
                                    </div>
                                </div>
                            </div>

                            <!-- 模块2：使用文档 -->
                            <div class="module_item" data-module="user-doc" style="margin-top:12px;">
                                <div class="module_header" @click="toggleModule('doc')">
                                    <div class="drag_handle" title="拖拽排序">⋮⋮</div>
                                    <div style="flex:1;">
                                        <p class="module_name">使用文档（PDF）</p>
                                        <div class="module_meta">
                                            <span>{{ docItems.length }} 条内容</span>
                                            <span class="tag tag_ok">内容来自文档库</span>
                                        </div>
                                    </div>
                                    <div class="button text" @click.stop="openAddModal('doc')" style="color:#507FF7; font-weight:720; font-size:13px;">+ 添加内容</div>
                                </div>
                                <div class="module_body" v-show="!docCollapsed">
                                    <div class="content_list" ref="docList">
                                        <div v-for="item in docItems" :key="item.id" class="content_row_item">
                                            <div class="drag_handle drag_handle_sm">⋮</div>
                                            <div class="content_row_title">{{ item.title }}</div>
                                            <div class="button text del_btn" @click="removeItem('doc', item)">移除</div>
                                        </div>
                                        <div v-if="docItems.length === 0" class="empty_hint">暂无内容，点击"+ 添加内容"开始配置</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notice_box">
                            App 下载和联系方式为全局配置。联系方式根据用户所在国家自动展示对应内容，请在 系统管理 > 联系方式配置 中维护。<br>模块标题按 多语言管理 中的翻译自动展示，无需手动修改。
                        </div>
                    </div>
                </div>

                <!-- 右列：手机预览 -->
                <div class="right_col">
                    <div class="config_card preview_card">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">H5 预览</h2>
                                <p class="config_card_subtitle">{{ searchForm.country }} / {{ searchForm.lang === 'en' ? 'English' : searchForm.lang === 'zh' ? '简体中文' : 'Deutsch' }} / {{ searchForm.product }}</p>
                            </div>
                            <div class="button text" @click="refreshPreview" style="color:#507FF7; font-weight:720; font-size:13px;">刷新</div>
                        </div>
                        <div class="phone_frame">
                            <div class="phone_container">
                                <div class="phone_h5_hero">
                                    <div class="h5_brand">RIKO Smart Care</div>
                                    <div class="h5_product">M1 Pro / Plus</div>
                                </div>
                                <div class="phone_content">
                                    <div class="phone_h5_section">
                                        <h5>App 下载</h5>
                                        <div class="phone_h5_download">
                                            <div class="phone_h5_dl_btn">iOS</div>
                                            <div class="phone_h5_dl_btn android">Android</div>
                                        </div>
                                    </div>

                                    <div v-if="videoItems.length > 0" class="phone_h5_section">
                                        <h5>开箱与安装视频</h5>
                                        <div v-for="vid in videoItems" :key="vid.id" class="phone_h5_video">
                                            <div class="play_icon">▶</div>
                                            <div class="vid_info">
                                                <div class="vid_title">{{ vid.title }}</div>
                                                <div class="vid_meta" v-if="vid.duration">{{ vid.duration }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="docItems.length > 0" class="phone_h5_section">
                                        <h5>使用文档</h5>
                                        <div v-for="doc in docItems" :key="doc.id" class="phone_h5_doc">
                                            <div class="doc_dot">PDF</div>
                                            <div class="doc_info">
                                                <div class="doc_title">{{ doc.title }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="phone_h5_section">
                                        <h5>联系我们</h5>
                                        <div class="phone_h5_contact">
                                            <div class="ct_title">400-000-0000</div>
                                            <div class="ct_meta">周一至周五 09:00-18:00</div>
                                        </div>
                                        <div class="phone_h5_contact" style="margin-top:4px;">
                                            <div class="ct_title">support@example.com</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加内容弹窗 -->
            <Gh-Dialog ref="addModal" title="从内容库添加" @dialogBack="confirmAdd">
                <template v-slot:content>
                    <div class="modal_filter">
                        <label>语言筛选</label>
                        <el-select v-model="modalFilterLang" placeholder="全部语言" style="width:150px;">
                            <el-option label="全部语言" value=""></el-option>
                            <el-option label="English" value="en"></el-option>
                            <el-option label="简体中文" value="zh"></el-option>
                            <el-option label="Deutsch" value="de"></el-option>
                        </el-select>
                    </div>
                    <div class="modal_list">
                        <div v-for="item in filteredModalItems" :key="item.id" class="modal_item" @click="toggleModalSelection(item.id)">
                            <div class="modal_check" :class="{selected: selectedModalIds.includes(item.id)}">
                                {{ selectedModalIds.includes(item.id) ? '✓' : '' }}
                            </div>
                            <div class="modal_item_content">
                                <div class="modal_item_title">{{ item.title }}</div>
                                <div class="modal_item_meta" v-if="item.meta">{{ item.meta }}</div>
                            </div>
                        </div>
                        <div v-if="filteredModalItems.length === 0" class="modal_empty">该语言下暂无内容</div>
                    </div>
                </template>
                <template v-slot:confirm_btn>
                    <div class="modal_foot">
                        <span class="modal_selected_count">已选 {{ selectedModalIds.length }} 条</span>
                        <div class="modal_foot_actions">
                            <div class="button cancel" @click="$refs.addModal.show = false">
                                <span>取消</span>
                            </div>
                            <div class="button" style="background:#507FF7; color:#fff;" @click="confirmAdd">
                                <span>确认添加</span>
                            </div>
                        </div>
                    </div>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: 'h5-quick-start',
    data() {
        return {
            // 筛选条件
            searchForm: {
                product: 'M1(Pro/Plus)',
                country: 'US',
                lang: 'en',
                fallback: 'en'
            },

            // 产品列表
            productOptions: ['M1(Pro/Plus)', 'M2', 'C1'],

            // 模块折叠状态
            videoCollapsed: false,
            docCollapsed: false,

            // 模块内容
            videoItems: [
                { id: 'v1-zh', title: '开箱检查与部件安装', duration: '03:20' },
                { id: 'v2-zh', title: '首次配网与绑定设备', duration: '02:45' }
            ],
            docItems: [
                { id: 'd1-zh', title: '快速使用指南' },
                { id: 'd2-zh', title: '电子说明书' }
            ],

            // 内容库数据
            videoLibrary: [
                { id: 'v1-en', title: 'Unboxing & Parts Assembly', lang: 'en' },
                { id: 'v2-en', title: 'First-time Network Setup', lang: 'en' },
                { id: 'v3-en', title: 'How to Clean the Litter Bin', lang: 'en' },
                { id: 'v1-zh', title: '开箱检查与部件安装', lang: 'zh' },
                { id: 'v2-zh', title: '首次配网与绑定设备', lang: 'zh' },
                { id: 'v3-zh', title: '如何拆洗猫砂盆', lang: 'zh' },
                { id: 'v1-de', title: 'Auspacken & Montage', lang: 'de' }
            ],
            docLibrary: [
                { id: 'd1-en', title: 'Quick Start Guide', lang: 'en' },
                { id: 'd2-en', title: 'Electronic Manual', lang: 'en' },
                { id: 'd1-zh', title: '快速使用指南', lang: 'zh' },
                { id: 'd2-zh', title: '电子说明书', lang: 'zh' },
                { id: 'd1-de', title: 'Schnellstartanleitung', lang: 'de' }
            ],

            // 弹窗状态
            currentModalType: '',
            modalFilterLang: '',
            selectedModalIds: [],

            // 发布状态
            publishStatus: '已发布',
            lastUpdateTime: '2026-06-16 14:30'
        }
    },

    computed: {
        filteredModalItems() {
            const lib = this.currentModalType === 'video' ? this.videoLibrary : this.docLibrary
            if (!this.modalFilterLang) {
                return lib
            }
            return lib.filter(item => item.lang === this.modalFilterLang)
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.initSortable('video')
            this.initSortable('doc')
        })
    },

    methods: {
        toggleModule(type) {
            if (type === 'video') {
                this.videoCollapsed = !this.videoCollapsed
            } else {
                this.docCollapsed = !this.docCollapsed
            }
        },

        openAddModal(type) {
            this.currentModalType = type
            this.selectedModalIds = []
            this.modalFilterLang = ''
            this.$refs.addModal.show = true
        },

        toggleModalSelection(id) {
            const idx = this.selectedModalIds.indexOf(id)
            if (idx >= 0) {
                this.selectedModalIds.splice(idx, 1)
            } else {
                this.selectedModalIds.push(id)
            }
        },

        confirmAdd() {
            if (this.selectedModalIds.length === 0) {
                this.$message.warning('请至少选择一条内容')
                return
            }

            const lib = this.currentModalType === 'video' ? this.videoLibrary : this.docLibrary
            const targetArr = this.currentModalType === 'video' ? this.videoItems : this.docItems

            this.selectedModalIds.forEach(id => {
                const item = lib.find(x => x.id === id)
                if (item && !targetArr.find(x => x.id === id)) {
                    targetArr.push({
                        id: item.id,
                        title: item.title,
                        duration: item.duration || null
                    })
                }
            })

            this.$refs.addModal.show = false
            this.$message.success(`已添加 ${this.selectedModalIds.length} 条内容`)
        },

        removeItem(type, item) {
            const arr = type === 'video' ? this.videoItems : this.docItems
            const idx = arr.indexOf(item)
            if (idx >= 0) {
                arr.splice(idx, 1)
            }
            this.$message.success('已移除')
        },

        initSortable(type) {
            const refName = type + 'List'
            const el = this.$refs[refName]
            if (!el) return

            new Sortable(el, {
                handle: '.drag_handle_sm',
                animation: 150,
                onEnd: ({ oldIndex, newIndex }) => {
                    if (oldIndex === newIndex) return
                    const arr = type === 'video' ? this.videoItems : this.docItems
                    const moved = arr.splice(oldIndex, 1)[0]
                    arr.splice(newIndex, 0, moved)
                }
            })
        },

        preview() {
            this.$message.info('预览功能即将上线')
        },

        refreshPreview() {
            this.$message.success('预览已刷新')
        },

        saveDraft() {
            this.$message.success('草稿已保存')
        },

        publish() {
            this.$message.success('发布成功')
        }
    }
}
</script>

<style lang="less" scoped>
@colorBlue2: #507FF7;
@colorBlue3: #E1EAFF;
@colorLine: #E8E9F1;
@colorDel: #EB534B;
@color333: #333;
@color666: #666;
@color999: #999;
@colorGreen: #21a67a;

.h5-quick-start-page {
    .title_flex {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
    }

    .status_row {
        display: flex;
        align-items: center;
        gap: 8px;
        color: @color666;
        font-size: 13px;
        white-space: nowrap;
    }

    .status_pill {
        height: 24px;
        display: inline-flex;
        align-items: center;
        padding: 0 9px;
        border-radius: 999px;
        background: #eef8f4;
        color: @colorGreen;
        font-size: 12px;
        font-weight: 800;
    }

    .top_actions {
        display: flex;
        gap: 10px;
        margin: 20px 0 30px;
        justify-content: flex-end;
    }

    // 信息卡片
    .info_card {
        display: flex;
        gap: 20px;
        align-items: flex-start;
        margin-bottom: 20px;
        padding: 16px;
        border: 1px solid #dbe7ff;
        border-radius: 12px;
        background: linear-gradient(135deg, #f7fbff, #ffffff);

        h2 {
            font-size: 15px;
            font-weight: 850;
        }

        p {
            color: @color666;
            font-size: 13px;
            line-height: 1.55;
            font-weight: 640;
        }
    }

    .source_list {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
    }

    .tag {
        height: 22px;
        display: inline-flex;
        align-items: center;
        padding: 0 8px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 760;

        &.tag_ok {
            background: #ebf9f4;
            color: @colorGreen;
        }
    }

    // 双列布局
    .layout_grid {
        display: grid;
        grid-template-columns: 1fr 340px;
        gap: 18px;
        align-items: start;
    }

    // 配置卡片通用样式
    .config_card {
        border: 1px solid @colorLine;
        border-radius: 12px;
        background: #fff;
        overflow: hidden;
    }

    .config_card_head {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        padding: 14px 16px;
        border-bottom: 1px solid @colorLine;

        > div:first-child {
            flex: 1;
        }
    }

    .config_card_title {
        font-size: 16px;
        font-weight: 840;
        margin: 0;
    }

    .config_card_subtitle {
        margin: 4px 0 0;
        color: @color666;
        font-size: 12px;
        font-weight: 620;
    }

    // 筛选区
    .filters_grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: 16px;
    }

    .filter_field {
        display: flex;
        flex-direction: column;
        gap: 6px;

        label {
            color: #4b5360;
            font-size: 12px;
            font-weight: 760;
        }

        .hint {
            color: @color999;
            font-size: 12px;
            font-weight: 620;
        }

        /deep/ .el-select {
            width: 100%;

            .el-input__inner {
                height: 38px;
                padding: 0 12px;
                border: 1px solid @colorLine;
                border-radius: 9px;
                font-size: 14px;
            }
        }
    }

    // 产品预览行
    .product_preview_row {
        display: grid;
        grid-template-columns: 56px 1fr;
        gap: 14px;
        align-items: center;
        padding: 0 16px 16px;
        border-top: 1px solid #f0f2f5;
        margin-top: 14px;
    }

    .product_thumb {
        width: 56px;
        height: 56px;
        border-radius: 10px;
        background: linear-gradient(135deg, #eef3ff, #f0f7ff);
        display: grid;
        place-items: center;
        color: @colorBlue2;
        font-size: 18px;
        font-weight: 900;
    }

    // 模块配置
    .modules_container {
        padding: 0;
    }

    .module_item {
        border: 1px solid @colorLine;
        border-radius: 12px;
        background: #fff;

        &:not(:first-child) {
            margin-top: 12px;
        }
    }

    .module_header {
        display: flex;
        grid-template-columns: 30px 1fr auto;
        align-items: center;
        gap: 12px;
        padding: 14px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: #f9f9fb;
        }
    }

    .drag_handle {
        width: 30px;
        height: 30px;
        display: grid;
        place-items: center;
        border-radius: 8px;
        background: #f7f8fb;
        color: #9aa2af;
        font-size: 18px;
        font-weight: 900;
        cursor: grab;
        flex-shrink: 0;

        &:active {
            cursor: grabbing;
        }

        &.drag_handle_sm {
            width: auto;
            background: none;
            padding: 0 6px;
            font-size: 14px;
            color: #c8ced8;
        }
    }

    .module_name {
        font-size: 15px;
        font-weight: 830;
        margin: 0;
    }

    .module_meta {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 5px;
        color: @color666;
        font-size: 12px;
        font-weight: 640;
    }

    .module_body {
        border-top: 1px solid @colorLine;
        padding: 0 14px 14px 56px;
    }

    .content_list {
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .content_row_item {
        display: grid;
        grid-template-columns: auto 1fr auto auto;
        align-items: center;
        gap: 12px;
        min-height: 52px;
        padding: 12px 0;
        border-bottom: 1px solid #f0f2f5;

        &:last-child {
            border-bottom: 0;
        }
    }

    .content_row_title {
        min-width: 0;
        font-size: 14px;
        font-weight: 720;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content_meta {
        font-size: 12px;
        color: @color999;
    }

    .empty_hint {
        padding: 20px;
        text-align: center;
        color: @color999;
        font-size: 13px;
    }

    // Notice
    .notice_box {
        padding: 12px 14px;
        border-radius: 10px;
        background: #eef3ff;
        color: #2a5090;
        font-size: 13px;
        line-height: 1.45;
        font-weight: 640;
        margin: 0 16px 16px;
    }

    // 手机预览
    .right_col {
        .preview_card {
            position: sticky;
            top: 84px;
        }
    }

    .phone_frame {
        margin: 16px auto;
        width: 292px;
        min-height: 540px;
        overflow: hidden;
        border: 10px solid #111827;
        border-radius: 36px;
        background: #f6f7f9;
        box-shadow: 0 20px 42px rgba(17, 24, 39, 0.16);
    }

    .phone_container {
        background: linear-gradient(180deg, #fbfcff, #f5f7fb);
        min-height: 540px;
        overflow-y: auto;
    }

    .phone_h5_hero {
        min-height: 110px;
        padding: 14px;
        border-radius: 0 0 18px 18px;
        background: linear-gradient(135deg, rgba(47, 109, 246, 0.12), rgba(49, 195, 214, 0.08));
    }

    .h5_brand {
        font-size: 10px;
        color: @color666;
        font-weight: 760;
        margin-bottom: 4px;
    }

    .h5_product {
        font-size: 18px;
        font-weight: 880;
        color: @color333;
    }

    .phone_content {
        padding: 10px;
        display: grid;
        gap: 8px;
    }

    .phone_h5_section {
        padding: 10px 12px;
        border-radius: 14px;
        background: #fff;

        h5 {
            font-size: 11px;
            font-weight: 800;
            margin: 0 0 7px;
        }
    }

    .phone_h5_download {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px;
    }

    .phone_h5_dl_btn {
        height: 32px;
        border-radius: 9px;
        background: #111827;
        color: #fff;
        display: grid;
        place-items: center;
        font-size: 10px;
        font-weight: 800;

        &.android {
            background: linear-gradient(135deg, #1a8f69, #2fc08c);
        }
    }

    .phone_h5_video {
        min-height: 42px;
        border-radius: 10px;
        background: linear-gradient(135deg, #dfeaff, #f0f7ff);
        margin-top: 6px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .play_icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.88);
        display: grid;
        place-items: center;
        font-size: 10px;
        color: @colorBlue2;
        flex-shrink: 0;
    }

    .vid_info {
        flex: 1;
    }

    .vid_title {
        font-size: 9px;
        font-weight: 780;
        color: @color333;
    }

    .vid_meta {
        font-size: 8px;
        color: @color666;
        margin-top: 2px;
    }

    .phone_h5_doc {
        min-height: 36px;
        border-radius: 9px;
        background: #f7f9fd;
        margin-top: 6px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .doc_dot {
        width: 24px;
        height: 24px;
        border-radius: 7px;
        background: #d99419;
        display: grid;
        place-items: center;
        color: #fff;
        font-size: 8px;
        font-weight: 900;
        flex-shrink: 0;
    }

    .doc_info {
        flex: 1;
    }

    .doc_title {
        font-size: 9px;
        font-weight: 780;
    }

    .phone_h5_contact {
        min-height: 36px;
        border-radius: 9px;
        background: #fbfcff;
        margin-top: 6px;
        padding: 8px 10px;
    }

    .ct_title {
        font-size: 9px;
        font-weight: 780;
    }

    .ct_meta {
        font-size: 8px;
        color: @color666;
        margin-top: 2px;
    }

    // 弹窗
    .modal_filter {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 20px;
        border-bottom: 1px solid #f0f2f5;

        label {
            font-size: 12px;
            font-weight: 760;
            color: #4b5360;
            white-space: nowrap;
        }
    }

    .modal_list {
        overflow-y: auto;
        padding: 8px 0;
        max-height: 340px;
    }

    .modal_item {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        gap: 12px;
        padding: 11px 20px;
        cursor: pointer;

        &:hover {
            background: #f7f9fd;
        }

        &.selected {
            background: #eef3ff;
        }
    }

    .modal_check {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        border: 2px solid #c8ced8;
        display: grid;
        place-items: center;
        flex-shrink: 0;
        color: #fff;
        font-size: 12px;
        font-weight: 800;

        &.selected {
            border-color: @colorBlue2;
            background: @colorBlue2;
        }
    }

    .modal_item_content {
        min-width: 0;
    }

    .modal_item_title {
        font-size: 14px;
        font-weight: 720;
    }

    .modal_item_meta {
        font-size: 12px;
        color: @color999;
        margin-top: 2px;
    }

    .modal_empty {
        padding: 40px 20px;
        text-align: center;
        color: @color666;
        font-size: 13px;
    }

    .modal_foot {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 20px;
        border-top: 1px solid @colorLine;
        background: #fafbfc;
    }

    .modal_selected_count {
        color: @color666;
        font-size: 13px;
        font-weight: 640;
    }

    .modal_foot_actions {
        display: flex;
        gap: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/h5-quick-start.vue